import * as React from "react";
import { ComponentImage } from '../library/ComponentImage';
import { RedditFrame } from '../components/RedditFrame';
import { YouTubeFrame } from '../components/YouTubeFrame';
import { Chat } from '../components/Chat';

const COMPONENT_NAME = "SidePanel";
const cx = require('classNames');


const BUTTON_FRAMING = {
    start: ['head','stretch','bridge-end'],
    center: ['bridge-start','stretch','stretch','stretch','bridge-end'],
    end: ['bridge-start','stretch','tail']
}

export class SidePanel extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            selectedMenuItem: 'end'
        }
    }

    selectMenuItem(menuItem) {
        this.setState((prevState)=>{
            prevState.selectedMenuItem = menuItem;
            return prevState;
        });
    }

    renderSet(parts, variant) {
        return parts.map((part) => {
            const path = variant ?
                `menu-${part}-${variant}.gif`:
                `menu-${part}.gif`;
            return (
                <ComponentImage
                    className={part + " item"}
                    component={COMPONENT_NAME}
                    file={path}
                />
            );
        })
    }

    renderButton(styles) {
        return [
            <div className="base">
                {this.renderSet(styles)}
            </div>,
            <div className="hover">
                {this.renderSet(styles, 'hover')}
            </div>,
            <div className="active">
                {this.renderSet(styles, 'active')}
            </div>,
        ];
    }

    renderSection(type, caption) {
        let classNames = {
            'button': true,
            'active': this.state.selectedMenuItem === type
        };
        classNames[type] = true;

        return (
            <div className={cx(classNames)}>
                {this.renderButton(BUTTON_FRAMING[type])}
                <div className="caption">
                    {caption}
                </div>
                <div className="target" onClick={()=>this.selectMenuItem(type)} />
            </div>
        );
    }

    renderMenu(start, center, end) {
        const { flipped } = this.props;
        return flipped ? (
            <div className="menu">
                {this.renderSection('start', end)}
                {this.renderSection('center', center)}
                {this.renderSection('end', start)}
            </div>
        ) : (
            <div className="menu">
                {this.renderSection('start', start)}
                {this.renderSection('center', center)}
                {this.renderSection('end', end)}
            </div>
        );
    }

    render() {
        const { flipped } = this.props;
        const { selectedMenuItem } = this.state;
        return (
            <div className="content">
                <div className="background" />
                {
                    flipped ? [
                        this.renderMenu("Games", "Streams", "Chat"),
                        selectedMenuItem === 'end' ? <RedditFrame subreddit="bitcoin" /> : null,
                        selectedMenuItem === 'center' ? <RedditFrame subreddit="ethtrader" /> : null,
                     ] : [
                         this.renderMenu(["Chat", "ChatB", "ChatC"]),
                        <Chat />
                     ]
                }
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./react/components/SidePanel.jsx